export type AffiliatedCompany = {
  id?: number
  parentCompanyId?: number
  childCompanyId?: number
  notes?: string
}
